const APPERSION = "2.0.3";
const APPHASH = "#d87c0edffc3132540855c44a88b083fde2987af1";

export const getApplicationVersion = () => {
  /*eslint-disable no-useless-concat*/
  if (APPERSION === "%APPLICATION" + "_" + "VERSION%") {
    return "dev-hot-reload";
  } else {
    return APPERSION;
  }
};
export const getApplicationHash = () => {
  if (APPHASH === "%APPLICATION" + "_" + "HASH%") {
    return "#dev-hot-reload";
  } else {
    return APPHASH;
  }
};
